export const allRanks = {
  Rank1: {
    items: [
      {
        item: "2x Experience Coupons",
        reboot: 0.083551,
        noMana: 0.0908574,
      },
      { item: "Berserker Ring", reboot: 0.018799, noMana: 0.020443 },
      { item: "Broken Box Pieces", reboot: 0.2819841, noMana: 0.3066438 },
      { item: "Clean Defense Ring", reboot: 0.018799, noMana: 0.020443 },
      { item: "Cleansing Ring", reboot: 0.0214099, noMana: 0.0232823 },
      { item: "Clean Stance Ring", reboot: 0.018799, noMana: 0.020443 },
      { item: "Crisis HM Ring", reboot: 0.0214099, noMana: 0 },
      { item: "Crisis H Ring", reboot: 0.018799, noMana: 0.020443 },
      { item: "Crisis M Ring", reboot: 0.018799, noMana: 0 },
      { item: "Critical Damage Ring", reboot: 0.0214099, noMana: 0.0232823 },
      { item: "Critical Defense Ring", reboot: 0.0214099, noMana: 0.0232823 },
      { item: "Critical Shift Ring", reboot: 0.018799, noMana: 0.020443 },
      { item: "Durability Ring", reboot: 0.018799, noMana: 0.020443 },
      { item: "Health Cut Ring", reboot: 0.0214099, noMana: 0.0232823 },
      { item: "Level Jump Ring", reboot: 0.0214099, noMana: 0.0232823 },
      { item: "Limit Ring", reboot: 0.0214099, noMana: 0 },
      { item: "Mana Cut Ring", reboot: 0.018799, noMana: 0 },
      { item: "Ocean Glow Earrings", reboot: 0.0057441, noMana: 0.0062465 },
      { item: "Overdrive Ring", reboot: 0.0214099, noMana: 0.0232823 },
      { item: "Oz Point Pouches", reboot: 0.067885, noMana: 0.0738216 },
      { item: "Reflective Ring", reboot: 0.018799, noMana: 0.020443 },
      { item: "Ring of Restraint", reboot: 0.0490861, noMana: 0.0533787 },
      { item: "Risk Taker Ring", reboot: 0.0302872, noMana: 0.0329358 },
      { item: "Stance Ring", reboot: 0.018799, noMana: 0.020443 },
      { item: "Swift Ring", reboot: 0.018799, noMana: 0.020443 },
      { item: "Totalling Ring", reboot: 0.0214099, noMana: 0.0232823 },
      { item: "Tower Boost Ring", reboot: 0.0214099, noMana: 0.0232823 },
      { item: "Ultimatum Ring", reboot: 0.0302872, noMana: 0.0329358 },
      { item: "Weapon Jump", reboot: 0.0302872, noMana: 0.0329358 },
    ],
  },
  Rank2: {
    items: [
      {
        item: "2x Experience Coupons",
        reboot: 0.1091619,
        noMana: 0.1182932,
      },
      { item: "Berserker Ring", reboot: 0.0191033, noMana: 0.0207013 },
      { item: "Broken Box Pieces", reboot: 0.2729046, noMana: 0.2957331 },
      { item: "Clean Defense Ring", reboot: 0.0191033, noMana: 0.0207013 },
      { item: "Cleansing Ring", reboot: 0.0194931, noMana: 0.0211238 },
      { item: "Clean Stance Ring", reboot: 0.0191033, noMana: 0.0207013 },
      { item: "Crisis HM Ring", reboot: 0.0194931, noMana: 0 },
      { item: "Crisis H Ring", reboot: 0.0191033, noMana: 0.0207013 },
      { item: "Crisis M Ring", reboot: 0.0191033, noMana: 0 },
      { item: "Critical Damage Ring", reboot: 0.0194931, noMana: 0.0211238 },
      { item: "Critical Defense Ring", reboot: 0.0194931, noMana: 0.0211238 },
      { item: "Critical Shift Ring", reboot: 0.0191033, noMana: 0.0207013 },
      { item: "Durability Ring", reboot: 0.0191033, noMana: 0.0207013 },
      { item: "Health Cut Ring", reboot: 0.0194931, noMana: 0.0211238 },
      { item: "Level Jump Ring", reboot: 0.0194931, noMana: 0.0211238 },
      { item: "Limit Ring", reboot: 0.0194931, noMana: 0 },
      { item: "Mana Cut Ring", reboot: 0.0191033, noMana: 0 },
      { item: "Ocean Glow Earrings", reboot: 0.0038986, noMana: 0.0042248 },
      { item: "Overdrive Ring", reboot: 0.0194931, noMana: 0.0211238 },
      { item: "Oz Point Pouches", reboot: 0.1091619, noMana: 0.1182932 },
      { item: "Reflective Ring", reboot: 0.0191033, noMana: 0.0207013 },
      { item: "Ring of Restraint", reboot: 0.0389864, noMana: 0.0422476 },
      { item: "Risk Taker Ring", reboot: 0.020273, noMana: 0.0219688 },
      { item: "Stance Ring", reboot: 0.0191033, noMana: 0.0207013 },
      { item: "Swift Ring", reboot: 0.0191033, noMana: 0.0207013 },
      { item: "Totalling Ring", reboot: 0.0194931, noMana: 0.0211238 },
      { item: "Tower Boost Ring", reboot: 0.0194931, noMana: 0.0211238 },
      { item: "Ultimatum Ring", reboot: 0.020273, noMana: 0.0219688 },
      { item: "Weapon Jump", reboot: 0.020273, noMana: 0.0219688 },
    ],
  },
  HiddenRing: {
    items: [
      { item: "Berserker Ring", reboot: 0.0606061, noMana: 0.0740741 },
      { item: "Clean Defense Ring", reboot: 0.0606061, noMana: 0.0740741 },
      { item: "Cleansing Ring", reboot: 0.030303, noMana: 0.037037 },
      { item: "Clean Stance Ring", reboot: 0.0606061, noMana: 0.0740741 },
      { item: "Crisis HM Ring", reboot: 0.030303, noMana: 0 },
      { item: "Crisis H Ring", reboot: 0.0606061, noMana: 0.0740741 },
      { item: "Crisis M Ring", reboot: 0.0606061, noMana: 0 },
      { item: "Critical Damage Ring", reboot: 0.030303, noMana: 0.037037 },
      { item: "Critical Defense Ring", reboot: 0.030303, noMana: 0.037037 },
      { item: "Critical Shift Ring", reboot: 0.0606061, noMana: 0.0740741 },
      { item: "Durability Ring", reboot: 0.0606061, noMana: 0.0740741 },
      { item: "Health Cut Ring", reboot: 0.030303, noMana: 0.037037 },
      { item: "Level Jump Ring", reboot: 0.030303, noMana: 0.037037 },
      { item: "Limit Ring", reboot: 0.030303, noMana: 0 },
      { item: "Mana Cut Ring", reboot: 0.0606061, noMana: 0 },
      { item: "Overdrive Ring", reboot: 0.030303, noMana: 0.037037 },
      { item: "Reflective Ring", reboot: 0.0606061, noMana: 0.0740741 },
      { item: "Ring of Restraint", reboot: 0.0075757, noMana: 0.0092592 },
      { item: "Risk Taker Ring", reboot: 0.0075757, noMana: 0.0092592 },
      { item: "Stance Ring", reboot: 0.0606061, noMana: 0.0740741 },
      { item: "Swift Ring", reboot: 0.0606061, noMana: 0.0740741 },
      { item: "Totalling Ring", reboot: 0.030303, noMana: 0.037037 },
      { item: "Tower Boost Ring", reboot: 0.030303, noMana: 0.037037 },
      { item: "Ultimatum Ring", reboot: 0.0075757, noMana: 0.0092592 },
      { item: "Weapon Jump", reboot: 0.0075757, noMana: 0.0092592 },
    ],
  },
  ShinyRing: {
    items: [
      { item: "Cleansing Ring", reboot: 0.0806452, noMana: 0.0961538 },
      { item: "Crisis HM Ring", reboot: 0.0806452, noMana: 0 },
      { item: "Critical Damage Ring", reboot: 0.0806452, noMana: 0.0961538 },
      { item: "Critical Defense Ring", reboot: 0.0806452, noMana: 0.0961538 },
      { item: "Health Cut Ring", reboot: 0.0806452, noMana: 0.0961538 },
      { item: "Level Jump Ring", reboot: 0.0806452, noMana: 0.0961538 },
      { item: "Limit Ring", reboot: 0.0806452, noMana: 0 },
      { item: "Overdrive Ring", reboot: 0.0806452, noMana: 0.0961538 },
      { item: "Ring of Restraint", reboot: 0.0483871, noMana: 0.0576923 },
      { item: "Risk Taker Ring", reboot: 0.0483871, noMana: 0.0576923 },
      { item: "Totalling Ring", reboot: 0.0806452, noMana: 0.0961538 },
      { item: "Tower Boost Ring", reboot: 0.0806452, noMana: 0.0961538 },
      { item: "Ultimatum Ring", reboot: 0.0483871, noMana: 0.0576923 },
      { item: "Weapon Jump", reboot: 0.0483871, noMana: 0.0576923 },
    ],
  },
};
